import React, { Fragment, useEffect, useState } from "react";
import { Button, Col, Row } from "reactstrap";
import { H6, P } from "../../../AbstractElements";
import { AnggaranUnit } from "../../../Constant";
import Chart from "react-apexcharts";
import { ChevronLeft, ChevronRight } from "react-feather";
import useAxios from "../../../Utils/useAxios";
import { formatRP } from "../../../Utils/externalFunctions";
import ModalRIB from "../../Anggaran Bulanan/component/ModalRIB";
import { useThemeContext } from "../../../Context/ThemeContext";
import { getDarkTableRow } from "../../../Utils/otherFunctions";
import CollapseableCard from "../../../CommonElements/Collapse/CollapseableCard";
import getRencImp from "../services/getRencImp";

const LatestAnggaran = (props) => {
  const axiosInstance = useAxios();
  const [rencImp, setRencImp] = useState([]);
  const [bukIndex, setBukIndex] = useState(0);
  const [selectedUK, setSelectedUK] = useState(null);
  const [selectedAnggaran, setSelectedAnggaran] = useState(0);
  const [isDefault, setIsDefault] = useState(false);

  const [modalRIBOpen, setModalRIBOpen] = useState(false);
  const toggleModalRIB = () => {
    setModalRIBOpen(!modalRIBOpen);
  };

  const { themeContext } = useThemeContext();

  const { updatedanggaranbuklist } = props;

  let isMounted = true;
  useEffect(() => {
    refreshRencImp();

    return () => {
      isMounted = false;
    };
  }, []);

  const refreshRencImp = async () => {
    getRencImp(axiosInstance).then((res) => {
      if (isMounted) {
        setRencImp(res.data);
      }
    });
  };

  const next = () => {
    if (bukIndex >= updatedanggaranbuklist.length - 1) {
      setBukIndex(0);
    } else {
      setBukIndex(bukIndex + 1);
    }
  };
  const prev = () => {
    if (bukIndex <= 0) {
      setBukIndex(updatedanggaranbuklist.length - 1);
    } else {
      setBukIndex(bukIndex - 1);
    }
  };

  const [options, setOptions] = useState({
    series: [0, 0],
    labels: ["Sisa", "Realisasi"],
    colors: ["#5fdc73", "#ef6057"],
  });

  useEffect(() => {
    if (updatedanggaranbuklist[bukIndex]) {
      const total_anggaran = updatedanggaranbuklist[bukIndex].total_anggaran;
      const total_sisa = updatedanggaranbuklist[bukIndex].total_sisa;
      const total_terpakai = updatedanggaranbuklist[bukIndex].total_terpakai;
      setOptions({
        series: [total_sisa / total_anggaran, total_terpakai / total_anggaran],
        labels: ["Sisa", "Realisasi"],
        colors: ["#5fdc73", "#ef6057"],
      });
      setSelectedUK(updatedanggaranbuklist[bukIndex]);
      setIsDefault(false);
    } else {
      setOptions({
        series: [0, 0],
        labels: ["Sisa", "Realisasi"],
        colors: ["#5fdc73", "#ef6057"],
      });
      setSelectedUK({
        id_unit_kerja: "Anggaran tidak ditemukan",
        total_anggaran: "0",
        total_sisa: "0",
        total_terpakai: "0",
      });
      setIsDefault(true);
    }
  }, [updatedanggaranbuklist, bukIndex]);

  return (
    <Fragment>
      <Col {...props}>
        <CollapseableCard title={AnggaranUnit}>
          <p className="text-center w-100" style={{ height: 40 }}>
            {selectedUK?.id_unit_kerja || "Anggaran tidak ditemukan"}
          </p>
          <div id="piechart" className="d-flex justify-content-center">
            <Chart
              options={options}
              series={options.series}
              type="pie"
              width={305}
            />
          </div>
          <div className="update-block">
            <Row className="d-flex mt-4 mb-3">
              <Col xl={4} className={"py-1"}>
                <div className={"text-center" + getDarkTableRow(themeContext)}>
                  <P>Total (Rp)</P>
                  <H6>{formatRP(selectedUK?.total_anggaran) || "0.00"}</H6>
                </div>
              </Col>
              <Col xl={4} className={"py-1"}>
                <div className={"text-center" + getDarkTableRow(themeContext)}>
                  <P>Realisasi (Rp)</P>
                  <H6>{formatRP(selectedUK?.total_terpakai) || "0.00"}</H6>
                </div>
              </Col>
              <Col xl={4} className={"py-1"}>
                <div className={"text-center" + getDarkTableRow(themeContext)}>
                  <P>Sisa (Rp)</P>
                  <H6>{formatRP(selectedUK?.total_sisa) || "0.00"}</H6>
                </div>
              </Col>
            </Row>
            <div className="text-center">
              <Button
                color="primary"
                className="rounded-2 my-4"
                onClick={() => {
                  setSelectedAnggaran(updatedanggaranbuklist[bukIndex]);
                  toggleModalRIB();
                }}
                disabled={isDefault}
              >
                Lihat Anggaran
              </Button>
            </div>
          </div>
          <div className="row position-absolute top-50 start-0 translate-middle-y">
            <Button
              color="link"
              className="rounded-circle"
              onClick={() => prev()}
            >
              <ChevronLeft />
            </Button>
          </div>
          <div className="row position-absolute top-50 end-0 translate-middle-y">
            <Button
              color="link"
              className="rounded-circle"
              onClick={() => next()}
            >
              <ChevronRight />
            </Button>
          </div>
        </CollapseableCard>
      </Col>
      {selectedUK && (
        <ModalRIB
          modal={modalRIBOpen}
          toggle={toggleModalRIB}
          selectedAnggaran={selectedAnggaran}
        />
      )}
    </Fragment>
  );
};
export default LatestAnggaran;
